import { useEffect, useRef, useState } from 'react';
import useSWR from 'swr';
import ShopController from '@/services/ShopController';
import { SHOP_URL } from '@/services/urls';

export const useShopSearch = ({ user, isMasterOrAdmin }) => {
	const [allShops, setAllShops] = useState([]);
	const [shopSearchText, setShopSearchText] = useState('');
	const [foundShops, setFoundShops] = useState([]);
	const [selectedShop, setSelectedShop] = useState(null);

	const dropdownShopRef = useRef();

	const { data: dataShops } = useSWR(
		!!user?.cityLocation && isMasterOrAdmin ? SHOP_URL : false,
		() => ShopController.getAll(user?.cityLocation?.id),
	);

	useEffect(() => {
		if (!dataShops?.shops) {
			return;
		}

		const shops = dataShops.shops.map(it => ({
			...it,
			label: it.name,
			value: it.id,
		}));
		setAllShops(shops);
	}, [dataShops?.shops]);

	const onShopSearch = value => {
		setShopSearchText(value);

		if (!value) {
			setFoundShops([]);
			return;
		}

		const valueLowerCase = value.toLowerCase();

		const newFoundShops = [];

		for (let i = 0; i < allShops.length; i++) {
			if (allShops[i].name.toLowerCase().startsWith(valueLowerCase)) {
				newFoundShops.push(allShops[i]);
			}
		}

		setFoundShops(newFoundShops);

		if (newFoundShops.length > 0) {
			if (newFoundShops.length === 1) {
				onShopSelect(newFoundShops[0].id);
			} else {
				dropdownShopRef.current.parentToggleModal(true);
			}
		}
	};

	const onShopSelect = shopId => {
		setSelectedShop(allShops.find(it => it.id === shopId));
		setFoundShops([]);
		setShopSearchText('');
		dropdownShopRef.current?.parentToggleModal(false);
	};

	const onFocusShop = () => {
		if (foundShops.length > 0) {
			dropdownShopRef.current.parentToggleModal(true, true);
		}
	};

	const resetShopSelection = () => {
		setSelectedShop(null);
		setFoundShops([]);
		setShopSearchText('');
	};

	return {
		allShops,
		shopSearchText,
		setShopSearchText,
		foundShops,
		setFoundShops,
		selectedShop,
		setSelectedShop,
		dropdownShopRef,
		onShopSearch,
		onShopSelect,
		onFocusShop,
		resetShopSelection,
	};
};
